import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { citysSelectMock, practitionersMock, practitionersSelectMock, specialtysSelectMock } from 'app/core/data/mock.json';
import { filterI } from 'app/core/interfaces/filter';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { AuthService } from 'app/core/http/services/auth.service';

@Component({
  selector: 'page-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  public title = "Agenda";
  public specialtys: filterI[] = [];
  public practitioners: filterI[] = [];
  public citys: filterI[] = [];
  public resultado: practitionerI[] = [];
  public form:FormGroup;
  public loading = false;

  constructor(
    private fb:FormBuilder,  
    private router: Router,
    private auth: AuthService
  ) {
    this.form = this.fb.group({
      email: ['',Validators.required],
      password: ['',Validators.required]
  });
   }

  ngOnInit(): void {
    this.loadFilters();
  }

  pesquisar(){
    //@TODO GET filter
    this.resultado = practitionersMock;
  }

  loadFilters() {
    //@TODO GET scpecialitys, practioner, citys
    this.specialtys = specialtysSelectMock;
    this.practitioners = practitionersSelectMock;
    this.citys = citysSelectMock;
  }

}
